
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { AthleteMetricsMixin, VuetifyMixin, BAIconsMixin } from '../../mixins';
import { getMetricUnit, getMetricUnitLabel } from '../../pipes';
import AthleteSelfAssessmentMetricDescription from './AthleteSelfAssessmentMetricDescription.vue';
import TestGroupHeader from './TestGroupHeader.vue';
import UserSelfReportSvg from '../svg/UserSelfReportSvg.vue';
import { SelfAssessmentTestModel } from '../../models/athlete/SelfAssessmentTestModel';
import { AthleteMetric } from '@/../types/enums';

@Component({
	components: {
		AthleteSelfAssessmentMetricDescription,
		TestGroupHeader,
		UserSelfReportSvg,
	},
})
export default class AthleteSelfAssessmentFormStep extends Mixins(AthleteMetricsMixin, VuetifyMixin, BAIconsMixin){
	getMetricUnit = getMetricUnit;
	getMetricUnitLabel = getMetricUnitLabel;
	@Prop({ default: false, type: Boolean }) isOpen: boolean;
	@Prop({ default: false, type: Boolean }) useOverlay: boolean;
	@Prop({ default: false, type: Boolean }) hideControls: boolean;
	@Prop({ required: true }) metric: AthleteMetric;
	@Prop({ required: true }) results: SelfAssessmentTestModel;
	private updateResults(results: SelfAssessmentTestModel){
		this.results = results;
		this.$emit('update:results', results);
	}

	showTestDialog: boolean = false;
	updateDialog(val: boolean){
		this.showTestDialog = val;
		this.$emit('update:show-test-dialog', val);
	}
	beginTest(){
		this.updateDialog(true);
	}
	redoTest(){
		this.clearResults();
		this.beginTest();
	}
	clearResults(){
		this.updateResults(new SelfAssessmentTestModel(this.metric));
	}

	closeDialog(){
		this.updateDialog(false);
	}

	get HasResults(): boolean{
		if(!this.results) return false;
		return this.results.finalResult !== null;
	}
	get FinalResult(): string{
		if(this.results.finalResultLabel){
			return `${this.results.finalResultLabel}${getMetricUnit(this.metric, true)}`;
		}
		return `${this.results.finalResult}${getMetricUnit(this.metric, true)}`;
	}

	get UseVelocity(): boolean{
		return this.metric === AthleteMetric.Speed;
	}
}
